export { default as Stats } from './lib/stats';
export { default as Stat } from './lib/stat';
export { default as _getHiResTimestamp } from './utils/hi-res-timestamp';
//# sourceMappingURL=index.js.map